export class CopyrightCheckerDossiersOverviewTableColumns {
    static Source = {
        maxWidth: '20%',
        translateKey: 'copyright_checker.dossier.source',
    };
    static DetectionCount = {
        translateKey: 'copyright_checker.dossier.detection_count',
    };
    static FullDetectionsCount = {
        translateKey: 'copyright_checker.dossier.full_detections_count',
    };
    static EmbeddedDetectionsCount = {
        translateKey: 'copyright_checker.dossier.embedded_detections_count',
    };
    static Status = {
        maxWidth: '25%',
        translateKey: 'copyright_checker.dossier.status',
    };
    static Actions = {
        translateKey: '',
    };
}
